
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp-backend-contact-completed",
      function () {
        return require("private-next-pages/lp-backend-contact-completed.tsx");
      }
    ]);
  